module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/trip/trip-add/trip-add.component.css
// module id = ./src/app/components/trip/trip-add/trip-add.component.css
// module chunks = main